var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 10,
    viewBox: "0 0 12.5 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_mail_outline_24px",
    d: "M13.25,4h-10A1.248,1.248,0,0,0,2.006,5.25L2,12.75A1.254,1.254,0,0,0,3.25,14h10a1.254,1.254,0,0,0,1.25-1.25V5.25A1.254,1.254,0,0,0,13.25,4Zm0,8.75h-10V6.5l5,3.125,5-3.125Zm-5-4.375-5-3.125h10Z",
    transform: "translate(-2 -4)",
    fill: "#185cff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMail);
export default __webpack_public_path__ + "static/media/report-mail.63c311527d196df5c657fa87958968ae.svg";
export { ForwardRef as ReactComponent };